import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { API, getAttribution, PRIVACY_POLICY_VERSION, TERMS_VERSION } from "@/lib/contact";

export const BUDGETS = ["Under ₹5,000", "₹5,000 – ₹15,000", "₹15,000 – ₹50,000", "₹50,000+"];
export const SERVICE_OPTIONS = ["Business Website", "Google Business Profile", "Local SEO", "Meta Ads", "Google Ads", "Social Media Setup", "WhatsApp Enquiries"];
export const INDUSTRIES = ["Retail / Local Shop", "Coaching / Education", "Clinic / Healthcare", "Real Estate", "Restaurant / Food", "Salon / Beauty", "Manufacturer / Wholesaler", "Other"];

const EMPTY = {
  name: "", mobile: "", email: "", business_name: "", industry: "", location: "",
  website_url: "", digital_presence: "", services_interested: [], budget: "",
  challenge: "", contact_time: "", message: "", consent: false, website: "",
};

export function useAgencyLead(type, extra = {}) {
  const [form, setForm] = useState({ ...EMPTY, ...extra });
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(null);

  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));
  const toggleService = (s) =>
    setForm((f) => ({
      ...f,
      services_interested: f.services_interested.includes(s)
        ? f.services_interested.filter((x) => x !== s)
        : [...f.services_interested, s],
    }));

  const normalizeMobile = (raw) => {
    let d = (raw || "").replace(/\D/g, "");
    if (d.length === 12 && d.startsWith("91")) d = d.slice(2);
    else if (d.length === 11 && d.startsWith("0")) d = d.slice(1);
    return d;
  };

  const submit = async () => {
    if (busy) return;
    if (!form.name.trim() || form.name.trim().length < 2) return toast.error("Please enter your name.");
    if (!/^[6-9]\d{9}$/.test(normalizeMobile(form.mobile))) return toast.error("Please enter a valid 10-digit mobile number.");
    if (!form.consent) return toast.error("Please accept the consent to continue.");
    setBusy(true);
    try {
      const attr = getAttribution();
      const payload = {
        ...form,
        type,
        mobile: normalizeMobile(form.mobile),
        email: form.email || null,
        ...attr,
        privacy_policy_version: PRIVACY_POLICY_VERSION,
        terms_version: TERMS_VERSION,
      };
      delete payload.website;
      const { data } = await axios.post(`${API}/agency/leads`, { ...payload, website: form.website });
      setDone(data);
      toast.success("Enquiry received! We'll contact you soon.");
    } catch (err) {
      const d = err?.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Submission failed. Please try WhatsApp instead.");
    } finally {
      setBusy(false);
    }
  };

  return { form, set, toggleService, busy, done, submit, reset: () => setDone(null) };
}
